import React from "react";
import { Box, Button, Skeleton, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { StatCard } from "../../components/shared";
import * as S from "./style";

interface ServiceHealth {
  up: number;
  down: number;
  total: number;
}

interface DashboardStats {
  health: any;
  serviceHealth: ServiceHealth;
  guidelinesCount: number;
  usersCount: number;
  adminUsersCount: number;
  demoUsersCount: number;
  celery: any;
}

interface DashboardPageProps {
  stats: DashboardStats;
  loading: boolean;
  onRefresh: () => void;
  onNavigate: (path: string) => void;
  user: any;
}

const DashboardPage: React.FC<DashboardPageProps> = ({
  stats,
  loading,
  onRefresh,
  onNavigate,
  user,
}) => {
  if (loading) {
    return (
      <Box>
        <Box sx={S.StyledHeaderBox}>
          <Skeleton variant="text" width={200} height={40} />
          <Skeleton variant="rounded" width={100} height={36} />
        </Box>
        <Box sx={S.StyledStatsGrid}>
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton
              key={i}
              variant="rounded"
              height={100}
              sx={{ borderRadius: 2 }}
            />
          ))}
        </Box>
        <Skeleton variant="rounded" height={160} sx={{ borderRadius: 2 }} />
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={S.StyledHeaderBox}>
        <Box>
          <Typography sx={S.StyledHeaderTitle}>Dashboard</Typography>
          <Typography sx={S.StyledHeaderSubtitle}>
            System overview and quick stats
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<RefreshIcon />}
          onClick={onRefresh}
        >
          Refresh
        </Button>
      </Box>

      {/* Stats Cards */}
      <Box sx={S.StyledStatsGrid}>
        <StatCard
          label="System Health"
          value={`${stats.serviceHealth.up}/${stats.serviceHealth.total}`}
          onClick={() => onNavigate("/system-health")}
        />
        <StatCard
          label="Guidelines"
          value={stats.guidelinesCount}
          onClick={() => onNavigate("/guidelines")}
        />
        <StatCard
          label="Users"
          value={stats.usersCount}
          details={`Admin: ${stats.adminUsersCount} • Demo: ${stats.demoUsersCount}`}
          onClick={() => onNavigate("/organisations")}
        />
        <StatCard
          label="Celery Tasks"
          value={stats.celery?.total ?? "—"}
          onClick={() => onNavigate("/celery")}
        />
      </Box>
    </Box>
  );
};

export default DashboardPage;
